import { InputSelectControlField } from '@sequencehq/core-components'
import {
  assignContactPurpose,
  isShippingContact,
  withoutPurpose
} from 'CustomerContacts/utils/contactPurposes'
import { CustomerFormFieldControls } from '../types'
import { fieldStyles } from '../sections/styles'
import { isValidContact } from './CustomerContactsField'

/**
 * Picks the shipping contact from the contacts being created. The pick lives on
 * the contacts themselves as the `SHIPPING` purpose, so removing a contact also
 * removes the pick.
 */
export const CustomerShippingContactField = ({
  contactsField,
  'data-testid': testId
}: {
  contactsField: CustomerFormFieldControls['contacts']
  'data-testid'?: string
}) => {
  const validContacts = contactsField.value.filter(isValidContact)
  // A picked contact whose name or email gets cleared stays listed, so the
  // select doesn't silently drop back to the placeholder.
  const selectableContacts = contactsField.value.filter(
    contact => isValidContact(contact) || isShippingContact(contact)
  )

  return (
    <InputSelectControlField
      data-testid={testId}
      label="Shipping contact"
      placeholder="Select contact"
      disabled={validContacts.length === 0}
      value={contactsField.value.find(isShippingContact)?.id ?? ''}
      onChange={contactId =>
        contactsField.onChange(
          assignContactPurpose(contactsField.value, contactId, 'SHIPPING')
        )
      }
      onClear={() =>
        contactsField.onChange(
          contactsField.value.map(contact =>
            withoutPurpose(contact, 'SHIPPING')
          )
        )
      }
      options={selectableContacts.map(contact => ({
        value: contact.id,
        label: contact.name,
        secondaryLabel: contact.email
      }))}
      styles={fieldStyles}
    />
  )
}
